var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentHeading',{staticClass:"h3 text-center",attrs:{"tag-name":_vm.tagName,"margin-bottom":_vm.marginBottom}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }